export type AdminRole = "admin" | "editor" | "viewer";

export interface AdminTraining {
  id: string;
  adminId: string;
  trainingId: string;
  role: AdminRole;
}

export interface AdminPermissions {
  role: AdminRole | null;
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canReorder: boolean;
  canEditField: (fieldName: string) => boolean;
}

export function buildAdminPermissions(role: AdminRole | null): AdminPermissions {
  if (!role) {
    return {
      role: null,
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canReorder: false,
      canEditField: () => false,
    };
  }

  if (role === "admin") {
    return {
      role,
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: true,
      canReorder: true,
      canEditField: () => true,
    };
  }

  if (role === "editor") {
    return {
      role,
      canView: true,
      canCreate: true,
      canEdit: true,
      canDelete: false,
      canReorder: true,
      canEditField: () => true,
    };
  }

  return {
    role,
    canView: true,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canReorder: false,
    canEditField: (fieldName) => fieldName === "comments",
  };
}
